import React, { useRef } from 'react';
import {
    Box,
    Button,
    Divider,
    Popover,
    useBreakpoint,
    useDisclosure,
} from '@landr/maestro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import { searchV3FilterType } from 'components/Filters/Filters';
import TypeFiltersContent from './FiltersContent/TypeFiltersContent';
import BpmFiltersContent from './FiltersContent/BpmFiltersContent';
import KeyFiltersContent from './FiltersContent/KeyFiltersContent';
import SearchToolsPopoverTrigger from './FiltersTrigger/SearchToolsPopoverTrigger';
import useSearchTools from './hooks/useSearchTools';

const SearchToolsPopover = ({
    toolsType,
}: {
    toolsType: searchV3FilterType;
}) => {
    const { isSearchBarDisabled } = useSearchBarContext();
    const { clearFilter, isTypeFilter, isBpmFilter, isKeyFilter } =
        useSearchTools({ toolsType });
    const isMobile = useBreakpoint('md');

    const { isOpen, onToggle, onClose } = useDisclosure();

    const ref = useRef<HTMLButtonElement>(null);

    return (
        <Popover
            placement={isTypeFilter ? 'bottom-start' : 'bottom-end'}
            offset={[0, 10]}
            isOpen={isOpen}
        >
            <SearchToolsPopoverTrigger
                toolsType={toolsType}
                onToggle={onToggle}
                ref={ref}
                isSearchBarDisabled={isSearchBarDisabled}
            />
            <Popover.Content
                minWidth={isTypeFilter ? '220px' : '360px'}
                padding="0"
                borderRadius="6px"
            >
                {isTypeFilter ? (
                    <TypeFiltersContent onClose={onClose} />
                ) : (
                    <>
                        <Box pt="2xl" pb="xl" px="lg">
                            {isBpmFilter && <BpmFiltersContent />}
                            {isKeyFilter && (
                                <KeyFiltersContent isMobile={isMobile} />
                            )}
                        </Box>
                        <Divider />
                        <Box
                            py="sm"
                            px="lg"
                            display={'flex'}
                            justifyContent={'space-between'}
                            gap={'xs'}
                        >
                            <Button
                                kind="link"
                                variant="secondary"
                                onClick={clearFilter}
                            >
                                Clear
                            </Button>
                            <Button isRounded size="sm" onClick={onToggle}>
                                Close
                            </Button>
                        </Box>
                    </>
                )}
            </Popover.Content>
        </Popover>
    );
};

export default SearchToolsPopover;
